import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'reports.networkPanel.title',
    defaultMessage: 'Executive Panel',
  },
  reopen: {
    id: 'reports.networkPanel.reopen',
    defaultMessage: 'Reopen Executive Panel',
  },
  loadError: {
    id: 'reports.networkPanel.loadError',
    defaultMessage: 'Unable to load the Executive Panel. Please try again.',
  },
  retry: {
    id: 'reports.networkPanel.retry',
    defaultMessage: 'Try again',
  },
});
